<app-alerts></app-alerts>

 

  <!--   <div class="row">
<div class="col-12">
		<h5 class="mainTitle">Профиль</h5>
</div>

</div> -->

  <div class="row">

  <div class="col-12 col-md-6  col-lg-4">
<nb-card>
           <nb-card-header>
               Дані
           </nb-card-header>
           <nb-card-body>
  	<div class="form-group">
	<label for="email">Email</label>
  	<input nbInput fullWidth [disabled]="true" value="{{authService.userData?.login || ''}}" id="email"/>
	</div>
	
  </nb-card-body>
 </nb-card>


	</div>


<!-- Selling. Until this existed an author could mark content for sale and never
     learn that no payment could reach them: the buyer got a "page not found" and
     the author got nothing at all. -->
  <div class="col-12 col-md-6  col-lg-4">
<nb-card>
	<nb-card-header>
		Продажі та донати
	</nb-card-header>
	<nb-card-body>

		<div *ngIf="sellerLoading" style="display:flex;"><div style="margin:auto;"><app-loader></app-loader></div></div>

		<div *ngIf="!sellerLoading">

			<div *ngIf="seller?.canSell" style="margin-bottom:12px;">
				<div style="font-weight:600; color:#4bb71b;">Приймання оплати підключено</div>
				<div style="font-size:12px; margin-top:6px;">
					Гроші за продані доступи та донати банк зараховує <b>напряму на рахунок вашого ФОП</b>.
					Комісія сервісу за вашим тарифом — <b>{{seller?.feePercent}}%</b> від кожного платежу, банк утримує її автоматично під час зарахування.
					Розмір комісії залежить від тарифу: що вищий тариф, то менша комісія.
				</div>
			</div>

			<!-- Not connected: what that means for THIS author, in the second person.
			     `seller.message` is the sentence the gate gives a BUYER ("the author has
			     not connected payments") and it was printed here verbatim, so an author
			     read about themselves in the third person, as a stranger. The machine
			     reason travels in `seller.reason`; the wording for each audience is
			     chosen where that audience is. -->
			<div *ngIf="!seller?.canSell" style="margin-bottom:12px;">
				<div style="font-weight:600;">{{sellerHeading}}</div>
				<div style="font-size:12px; margin-top:6px;">{{sellerExplanation}}</div>
				<div style="font-size:12px; margin-top:6px; color:#8f9bb3;" *ngIf="sellerCheckedAt">Останню перевірку в банку зроблено {{sellerCheckedAt}}. Перевіряємо автоматично кожні 10 хвилин.</div>
				<div style="font-size:12px; margin-top:6px;"
					*ngIf="seller?.status === 'none' && seller?.feePercent !== null">
					Після підключення банк зараховуватиме кошти напряму на ваш рахунок ФОП,
					утримуючи комісію сервісу — <b>{{seller?.feePercent}}%</b> за вашим тарифом.
				</div>
				<div style="font-size:12px; margin-top:6px; color:#ff3d71;" *ngIf="seller?.note">{{seller?.note}}</div>
			</div>

			<!-- An active seller who edited their payout details: the bank settles to
			     the account the terminal was onboarded with until an operator redoes it. -->
			<div *ngIf="seller?.reonboardRequired" style="font-size:12px; margin-bottom:12px; color:#ff8c00;">
				Нові реквізити ще не підтверджені банком. До підтвердження кошти
				зараховуються на рахунок, вказаний під час підключення.
			</div>

			<button nbButton status="primary" (click)="openSellerForm()">
				{{ seller?.status === 'none' || !seller ? 'Підключити приймання оплати' : 'Змінити дані заявки' }}
			</button>

		</div>
	</nb-card-body>
</nb-card>

<!-- The application itself. It lives in a dialog and closes when it is sent:
     this page is where someone changes a password, and a payments questionnaire
     unfolded down its whole length is in the way of everyone who is not applying. -->
<ng-template #sellerModal let-ref="dialogRef">
	<nb-card style="max-width:520px; width:100%; margin:0;">
		<nb-card-header>
			<div style="display:flex; width:100%; align-items:center;">
				<span>{{ seller?.status === 'none' || !seller ? 'Підключення приймання оплати' : 'Дані заявки' }}</span>
				<span style="display:flex; margin-left:auto; cursor:pointer;" (click)="ref.close()">
					<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
				</span>
			</div>
		</nb-card-header>
		<nb-card-body>

			<div class="form-group">
				<label>Найменування ФОП</label>
				<input nbInput fullWidth [(ngModel)]="sellerForm.fop_name" placeholder="ФОП Прізвище Ім'я По батькові" />
			</div>
			<div class="form-group">
				<label>ІПН / ЄДРПОУ</label>
				<input nbInput fullWidth [(ngModel)]="sellerForm.tax_id" placeholder="0123456789" />
			</div>
			<div class="form-group">
				<label>Телефон</label>
				<input nbInput fullWidth [(ngModel)]="sellerForm.phone" placeholder="+380991234567" />
			</div>
			<div class="form-group">
				<label>Email ФОП</label>
				<input nbInput fullWidth type="email" [(ngModel)]="sellerForm.contact_email" placeholder="fop@example.com" />
				<div style="font-size:11px; margin-top:4px; opacity:0.7;">
					Пошта ФОП для банку. Якщо пошта кабінету інша - вкажіть тут ту, що належить ФОП.
				</div>
			</div>

			<!-- The bank's application asks for these as well. They are prefilled from
			     the author's channel, because a shop link retyped by hand is a link the
			     bank cannot open - but they stay editable, since a channel title is not
			     always how a seller wants to appear on a receipt. -->
			<div class="form-group">
				<label>Вид діяльності</label>
				<input nbInput fullWidth [(ngModel)]="sellerForm.activity" placeholder="Чим ви займаєтесь" />
			</div>
			<div class="form-group">
				<label>Назва торгової точки</label>
				<input nbInput fullWidth [(ngModel)]="sellerForm.shop_name" placeholder="Назва вашого каналу або бренду" />
			</div>
			<div class="form-group">
				<label>Посилання на вашу сторінку</label>
				<input nbInput fullWidth [(ngModel)]="sellerForm.shop_url" placeholder="https://livestream.ua/channel/..." />
			</div>
			<div class="form-group">
				<label>Логотип</label>
				<input nbInput fullWidth [(ngModel)]="sellerForm.logo_url" placeholder="https://livestream.ua/uploads/..." />
				<div style="font-size:11px; margin-top:4px; opacity:0.7;">
					Банк вимагає зображення. За замовчуванням - аватар вашого каналу.
				</div>
			</div>

			<div class="form-group" style="font-size:12px;">
				<label style="display:flex; align-items:flex-start; cursor:pointer;">
					<input type="checkbox" [(ngModel)]="sellerForm.oferta" style="margin-right:8px; margin-top:3px;" />
					<span>Приймаю умови <a href="/ldata/oferta.html" target="_blank">публічної оферти</a></span>
				</label>
			</div>

			<div style="color:#ff3d71; font-size:12px;" *ngIf="sellerError">{{sellerError}}</div>

		</nb-card-body>
		<nb-card-footer>
			<div style="display:flex; width:100%;">
				<button nbButton status="primary" [nbSpinner]="sellerSaving" [disabled]="sellerSaving"
					(click)="submitSellerRequest(ref)">
					{{ seller?.status === 'none' || !seller ? 'Надіслати заявку' : 'Зберегти' }}
				</button>
				<button nbButton status="basic" style="margin-left:12px;" (click)="ref.close()">Скасувати</button>
			</div>
		</nb-card-footer>
	</nb-card>
</ng-template>
	</div>



 <div class="col-12 col-md-6  col-lg-4">

<nb-card>
           <nb-card-header>
               Зміна пароля
           </nb-card-header>
           <nb-card-body>
            <form autocomplete="off" [formGroup]="form" (ngSubmit)="submit()" >
		<div class="form-group">
			<label for="password">Пароль</label>
		  	<input nbInput fullWidth [disabled]="true" autocomplete="off" type="password"  formControlName="password"  id="password"/>
			

		<div>

			   <span *ngIf="form.get('password').invalid && form.get('password').touched" class="caption status-danger">
                 <span *ngIf="form.get('password').errors.required">Пароль не може бути порожнім</span>
                 <span *ngIf="form.get('password').errors.minlength">
                   Мінімальна довжина пароля  {{form.get('password').errors.minlength.requiredLength }} символів.
                   Зараз {{form.get('password').errors.minlength.actualLength }}
                 </span>
                </span>
		</div>

	
		<div style="margin-bottom:15px; margin-top:7px;"><a href="javascript:;" (click)="openCreatePasswordModal(createPassword)">Запросити новий пароль</a></div>

		</div>

		<div class="form-group">
			<label for="new_password">Новий пароль</label>
		  	<input nbInput fullWidth [disabled]="true" autocomplete="off" type="password" formControlName="new_password"  id="new_password"/>

		<div>

			   <span *ngIf="form.get('new_password').invalid && form.get('new_password').touched" class="caption status-danger">
                 <span *ngIf="form.get('new_password').errors.required">Пароль не може бути порожнім</span>
                 <span *ngIf="form.get('new_password').errors.minlength">
                   Мінімальна довжина пароля {{form.get('new_password').errors.minlength.requiredLength }} символів.
                   Зараз {{form.get('new_password').errors.minlength.actualLength }}
                 </span>
                </span>
		</div>

		</div> 

		<div class="form-group">
			<label for="rp_password">Повторіть пароль</label>
		  	<input nbInput fullWidth [disabled]="true" autocomplete="off" type="password"  formControlName="rp_password"  id="rp_password"/>


			<div>

			   <span *ngIf="form.get('rp_password').invalid && form.get('rp_password').touched" class="caption status-danger">
                 <span *ngIf="form.get('rp_password').errors.required">Пароль не може бути порожнім</span>
                 <span *ngIf="form.get('rp_password').errors.minlength">
                   Мінімальна довжина пароля {{form.get('rp_password').errors.minlength.requiredLength }} символів.
                   Зараз {{form.get('rp_password').errors.minlength.actualLength }}
                 </span>

                <span *ngIf="form.get('rp_password').errors.confirmedValidator">Пароль не співпав</span>
                </span>
		</div>

		</div>


		<div class="form-group">
			 <button  nbButton fullWidth size="large" status="primary"  [disabled]="form.invalid || form.disabled"
                type="submit">Змінити пароль</button>
		</div>
	</form>
  </nb-card-body>
 
 </nb-card>

	</div>

	</div>












 <ng-template #createPassword let-data   let-ref="dialogRef">

  <div style="max-width:400px">
         <nb-card>
      <nb-card-header>
  
    
    <div style="display:flex; width:100%">
      <span>Створити новий пароль?</span>   
       <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="ref.close()">
<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
	</span>  
    </div>
  </nb-card-header>
      <nb-card-body>
    <div>
        
         
      <p>Увага! Буде згенерований новий пароль і відправлений вам на пошту. Ви не зможете зайти в аккаунт використовуючи свій поточний пароль. Ви впевнені, що хочете створити новий пароль?</p>
  
    </div>
  </nb-card-body>
      <nb-card-footer>
       
         
    <div style="display:flex; width:100%">
            
            <button style="display:flex; margin-left:auto; cursor: pointer;" (click)="generateNewPassword(ref)" nbButton status="danger" >Створити пароль</button>
            <button style="display:flex; margin-left:15px; cursor: pointer;" (click)="ref.close()" nbButton status="basic" >Скасувати</button>

  
          </div>
      </nb-card-footer>
    </nb-card>
     
  </div>
    </ng-template>
    


	 <div *ngIf="loading" style="position: fixed; z-index: 1777; background-color:rgba(0,0,0,0.5); width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
        <div style="margin: auto;"> 
             <app-loader></app-loader>
         </div>
        </div>
  
